import { RESOLUTION_LIST } from "./enum.js";
class ResolutionManager {
  constructor() {
     //make this Singleton
    
    if (ResolutionManager.instance) {
      return ResolutionManager.instance;
    }
    window.RESOLUTION = this.checkResolution();
  }

  checkResolution() {
    let innerHeight = window.innerHeight;

    if (innerHeight >= 720 && innerHeight < 1080) {
      return RESOLUTION_LIST.HD;
    } else if (innerHeight >= 1080 && innerHeight < 2160) {
      return RESOLUTION_LIST.FHD;
    } else if (innerHeight >= 2160) {
      return RESOLUTION_LIST["4K"];
    }
  }

  vwTopx(vwValue) {
    const width = window.innerWidth;
    return `${(vwValue / 100) * width}px`;
  }

  vHTopx(vwValue) {
    const height = 1080;
    return `${(vwValue / 100) * height}px`;
  }
  
}



window.resolutionManager = new ResolutionManager();
console.log("resolutionManager.js",window.RESOLUTION);



export { ResolutionManager };
